import { Component, OnInit, Input, OnDestroy, EventEmitter } from '@angular/core';
import { EstadoItens } from '../../../../models/estadoItens.model';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { DataModelComponent } from '../../../../models/data.model.component';
import { UsersService } from '../../../../models/usuarios.service';
import { CarrinhoItemsModel } from '../../../../models/carrinhoItems.model';
import { QueryFn, AngularFirestore } from '../../../../node_modules/angularfire2/firestore';


@Component({
  selector: 'app-monitor',
  templateUrl: './monitor.component.html',
  styleUrls: ['./monitor.component.scss']
})
export class MonitorComponent extends DataModelComponent<any> implements OnInit, OnDestroy {
  fornecedor: number = 0;
  primeiraCarga: boolean = true;
  dataPedido: Date = new Date();
  startDate: Date = new Date();
  vf: boolean = false;
  stepIndex: number = 0;
  private _filaVazia: boolean = true


  set filaVazia(value: boolean) {

    if (!value) {
      let pedidoModel = new CarrinhoItemsModel(this.usersService.usuarioClass.dbConn, this.usersService)
      pedidoModel.playAudio('novoPedido.wav')
    }

    this._filaVazia = value
  }

  get filaVazia() {
    return this._filaVazia
  }
  pesquisaOutput: EventEmitter<string> = new EventEmitter<string>()
  get verFechados(): boolean {
    return this.vf;
  }
  set verFechados(x) {
    this.vf = x;
    this.primeiraCarga = true;
    this.fechadoChange();
  }
  estadosClass: EstadoItens = null;
  dataEvent: Subscription;
  pesquisaValue: string = ''
  @Input()
  estados = [];
  fEstado: any = {};
  canModify = true;


  @Input()
  get estado() {
    return this.fEstado;
  }
  set estado(x) {
    this.fEstado = x;
  }

  constructor (private db: AngularFirestore, private usersService: UsersService) {
    super({
      verFechados: new FormControl(),
      dataPedido: new FormControl(),
    });
    this.fornecedor = usersService.usuario.fornecedor;
    this.canModify = usersService.isFornecedor || usersService.isGestor;
  }

  ngOnInit() {
    this.estadosClass = new EstadoItens(this.db);
    this.dataEvent = this.estadosClass.changedEvent.subscribe
      ((data: Array<any>) => {
        if (!this.verFechados) { //alguns documentos estão vindo sem o compo finalizado ,
          // não foi possivel filtrar no server         
          this.estados = data.filter((elem) => ((elem.codigo != 0) && (!elem.finalizado)))
        }
        else {
          this.estados = data.filter((elem) => ((elem.codigo != 0) && (elem.finalizado)))
        }

        this.estados = this.estados.sort((a, b) => {
          return (a.ordem > b.ordem ? 1 : (a.ordem < b.ordem ? -1 : 0));
        });

        this.estado = data[0];
      })
    this.reopen();
  }
  okDlg(msg) {
    alert(msg);
  }

  ngOnDestroy() {
    this.dataEvent.unsubscribe();
  }

  reopen() {
    this.primeiraCarga = true;
    this.estadosClass.snapshot(
      r => r.where('inativo', '==', false)
      , null, true);
  }

  fechadoChange() {
    this.reopen();
    this.stepIndex = 0
  }

  doChangeStep(event) {
    this.stepIndex = event.selectedIndex;

  }

  filtrarData() {
    console.log(this.dataPedido);
  }

  dataChange($event) {
    this.dataPedido = $event.value;
    console.log(this.dataPedido);
  }

  pesquisaPedido() {
    let where: QueryFn
    let callback: Function
    let nPedido: any
    let porPedido: boolean
    let pedidoModel: CarrinhoItemsModel
    pedidoModel = new CarrinhoItemsModel(this.usersService.usuarioClass.dbConn, this.usersService)

    this.pesquisaValue = this.pesquisaValue.trim()
    nPedido = Number(this.pesquisaValue)
    porPedido = !isNaN(nPedido)
    if (porPedido) {
      where = (elem) => {
        return elem.where('pedido', '==', String(nPedido))
          .where('fornecedor', '==', this.usersService.fornecedor)
      }
    }

    callback = (data) => {
      if (data && (data.length > 0)) {
        if (porPedido) {
          let indexEstado: number = this.estados.findIndex((elem) => (elem.codigo == data[0].estado))
          if (indexEstado !== -1) {
            //this.stepIndex = indexEstado // muda o stepper para posição do pedido
            this.pesquisaValue = String(nPedido)
          }
        }
      }
      else {
        this.okDlg('Pedido não encontrado')
      }
    }

    pedidoModel.pedidoClass.snapshot(where, callback, true)
  }

}
